import { render, staticRenderFns } from "./simple_product.vue?vue&type=template&id=e9221b3e&"
import script from "./simple_product.vue?vue&type=script&lang=js&"
export * from "./simple_product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports